/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetFavorites200ResponseAllOfData } from './GetFavorites200ResponseAllOfData';
import {
    GetFavorites200ResponseAllOfDataFromJSON,
    GetFavorites200ResponseAllOfDataFromJSONTyped,
    GetFavorites200ResponseAllOfDataToJSON,
} from './GetFavorites200ResponseAllOfData';
import type { ResponseSuccessWithPagingAllOfMeta } from './ResponseSuccessWithPagingAllOfMeta';
import {
    ResponseSuccessWithPagingAllOfMetaFromJSON,
    ResponseSuccessWithPagingAllOfMetaFromJSONTyped,
    ResponseSuccessWithPagingAllOfMetaToJSON,
} from './ResponseSuccessWithPagingAllOfMeta';

/**
 * 
 * @export
 * @interface GetFavorites200Response
 */
export interface GetFavorites200Response {
    /**
     * 
     * @type {GetFavorites200ResponseAllOfData}
     * @memberof GetFavorites200Response
     */
    data: GetFavorites200ResponseAllOfData;
    /**
     * 
     * @type {ResponseSuccessWithPagingAllOfMeta}
     * @memberof GetFavorites200Response
     */
    meta: ResponseSuccessWithPagingAllOfMeta;
}

/**
 * Check if a given object implements the GetFavorites200Response interface.
 */
export function instanceOfGetFavorites200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetFavorites200ResponseFromJSON(json: any): GetFavorites200Response {
    return GetFavorites200ResponseFromJSONTyped(json, false);
}

export function GetFavorites200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFavorites200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetFavorites200ResponseAllOfDataFromJSON(json['data']),
        'meta': ResponseSuccessWithPagingAllOfMetaFromJSON(json['meta']),
    };
}

export function GetFavorites200ResponseToJSON(value?: GetFavorites200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetFavorites200ResponseAllOfDataToJSON(value.data),
        'meta': ResponseSuccessWithPagingAllOfMetaToJSON(value.meta),
    };
}

